import { render } from "./mobile_notification.vue?vue&type=template&id=3053da2e"
import script from "./mobile_notification.vue?vue&type=script&lang=js"
export * from "./mobile_notification.vue?vue&type=script&lang=js"
script.render = render

export default script